// Empire Apps Chassis · connectors/financial · index
// Registry + uniform iteration over all financial connectors.

import type { Connector } from './types.ts';
import { sahamatiAa } from './sahamati-aa.ts';
import { gmailStatementParser } from './gmail-statement-parser.ts';
import { kiteConnect } from './kite-connect.ts';
import { upstoxConnect, growwConnect, angelOneConnect } from './upstox-groww-angel.ts';
import { mfapiExtended } from './mfapi-extended.ts';
import { camsCas } from './cams-cas.ts';
import { epfoPassbook } from './epfo-passbook.ts';
import { aisTis } from './ais-tis.ts';
import { creditReport } from './credit-report.ts';
import { razorpayHistory } from './razorpay-history.ts';
import { bharatBillPay } from './bharat-bill-pay.ts';
import { upiExportParser } from './upi-export-parser.ts';
import { smsInboxAndroid } from './sms-inbox-android.ts';

export * from './types.ts';
export * from './dpdp-purposes.ts';
export { sahamatiAa, SUPPORTED_FIPS } from './sahamati-aa.ts';
export { gmailStatementParser, SUPPORTED_BANK_FORMATS, parseStatementText, statementLinesToTransactions } from './gmail-statement-parser.ts';
export { kiteConnect } from './kite-connect.ts';
export { upstoxConnect, growwConnect, angelOneConnect } from './upstox-groww-angel.ts';
export { mfapiExtended, fetchLatestNav, fetchAmfiNavAll, parseAmfiNavAll, parseCamsCasText } from './mfapi-extended.ts';
export { camsCas } from './cams-cas.ts';
export { epfoPassbook, parseEpfoPassbook } from './epfo-passbook.ts';
export { aisTis, parseAisJson, parseAisPdfText } from './ais-tis.ts';
export { creditReport, parseCreditPdfText } from './credit-report.ts';
export { razorpayHistory, fetchRazorpayPayments } from './razorpay-history.ts';
export { bharatBillPay } from './bharat-bill-pay.ts';
export { upiExportParser, parseUpiCsv, detectProvider } from './upi-export-parser.ts';
export { smsInboxAndroid, parseTransactionSms } from './sms-inbox-android.ts';

export const ALL_FINANCIAL_CONNECTORS: readonly Connector[] = Object.freeze([
  sahamatiAa,
  gmailStatementParser,
  kiteConnect,
  upstoxConnect,
  growwConnect,
  angelOneConnect,
  mfapiExtended,
  camsCas,
  epfoPassbook,
  aisTis,
  creditReport,
  razorpayHistory,
  bharatBillPay,
  upiExportParser,
  smsInboxAndroid,
]);

export const CONNECTORS_BY_ID: Readonly<Record<string, Connector>> = Object.freeze(
  Object.fromEntries(ALL_FINANCIAL_CONNECTORS.map((c) => [c.id, c])),
);

export const HISAAB_CONNECTORS: readonly string[] = Object.freeze([
  'gmail-statement',
  'upi-export-parser',
  'bharat-bill-pay',
  'sms-inbox-android',
  'sahamati-aa',
]);

export const KHAZAANA_CONNECTORS: readonly string[] = Object.freeze([
  'sahamati-aa',
  'mfapi-extended',
  'cams-cas',
  'kite-connect',
  'upstox',
  'groww',
  'angel-one',
  'epfo-passbook',
]);

export const TANKHWAH_CONNECTORS: readonly string[] = Object.freeze([
  'ais-tis',
  'epfo-passbook',
  'gmail-statement',
  'credit-report',
  'razorpay-history',
]);
